export class OidcAudience {
    id: string;
    oidcIssuerId: string;
    audience: string;
    restrictedToOrganizationIds: any;
    active: boolean;;
    createdBy: string;
    createdAt: string;
    deletedAt: string;
    selected = false;
    deletedBy: string;
    deleted: boolean;
}
